// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2mY_X","bigColWidth":"Table_bigColWidth__GD3TF","biggerColWidth":"Table_biggerColWidth__3AZYe","row":"Table_row__2G6cD","col":"Table_col__3W-tj"};